import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Inrevactiveph from "../../assets/pic/interactive.jpg"
import {Helmet} from "react-helmet";

const InteractiveEn = ()=>{
    return(
        <div className='interactive-wrap'>
            <Helmet>
                <title>Interactive events</title>
                <meta name="description" content="Online (virtual) events have considerable advantages such as reduced costs for participants and the organizer, increased number of participants, and increased interaction since it is independent of the aspects of time and place." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>Interactive combined events</h1>
                <img src={Inrevactiveph} alt="Interactive events"/>
                <p>
                    Online (virtual) events have considerable advantages such as reduced costs for participants and the organizer, increased number of participants, and increased interaction since it is independent of the aspects of time and place. Click this link for the advantages of holding events such as online exhibitions.
                </p>
                <p>
                    Despite all the significant advantages an online event could have, some people prefer to hold physical events because of their nostalgic feeling. It is evident that you need to grow your statistical population to be more successful and increase your interaction with the participants.
                </p>
                <p>
                    Therefore, you could share the contents of your event online using standard interactive tools alongside holding a physical event to gain a larger coverage of participants.
                </p>
                <p>
                    BellMeet comprehensive online meeting platform, the only knowledge-based and native platform, is prepared to host your online meetings and seminars using the most advanced interactive tools that are mentioned as follows:
                </p>
                <ul>
                    <li>•	High-quality audio interaction</li>
                    <li>•	High-quality video interaction with the possibility of multiple video connections</li>
                    <li>•	Playing videos online </li>
                    <li>•	Text conversation and interaction (chatting)</li>
                    <li>•	Sharing files</li>
                    <li>•	Sharing desktops</li>
                    <li>•	The possibility of displaying important announcements or messages in the meeting environment periodically</li>
                </ul>
                <p>
                    Ready to host your online event platform.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default InteractiveEn